import {useSessionStore} from '@/stores'
import {jsonRpc} from '@communication'
import {onMounted, onUnmounted} from 'vue'

export const useParticipantReadyCallback = () => {
  const session = useSessionStore()

  const onParticipantReady = (event: CustomEvent) => {
    const {id} = event.detail
    session.updateParticipant(id, {status: 'online'})
  }
  onMounted(() => {
    jsonRpc.on('con:ready', onParticipantReady)
  })
  onUnmounted(() => {
    jsonRpc.off('con:ready', onParticipantReady)
  })
}
